import Menu from '@jsclasses/menu/menu';

import { listenDOMEvent } from '@jspartials/dom-api-utils';
import { createMenu, createSubmenu } from '@jspartials/menu-utils';
import {
  classes,
  addClassToElement,
  removeClassToElement,
  hasClassElement
} from '@jspartials/class-list-utils';

const selector = {
  menuMobile: '.js-menu-mobile',
  menuMobileContent: '.js-menu-mobile__content',
  buttonGenderMobile: '.js-menu-mobile__gender-option',
  buttonCategory: '.js-menu-mobile__category',
  buttonOpenMenuMobile: '.js-menu-mobile__open-menu-button',
  buttonCloseMenuMobile: '.js-menu-mobile__close-menu-button',
  buttonCloseSubmenuMobile: '.js-menu-mobile__close-submenu-button',
  desktopMobileMenuWrapper: '.js-menu-mobile__main-menu'
};

export default class Mobile extends Menu {
  constructor() {
    super(
      selector.menuMobile,
      selector.menuMobileContent,
      selector.desktopMobileMenuWrapper,
      selector.buttonGenderMobile
    );

    this.categoryButtons = document.querySelectorAll(selector.buttonCategory);
    this.openButtonElement = document.querySelector(
      selector.buttonOpenMenuMobile
    );
    this.closeButtonElements = document.querySelectorAll(
      selector.buttonCloseMenuMobile
    );
    this.closeSubmenuButtonElement = document.querySelector(
      selector.buttonCloseSubmenuMobile
    );
    this.initEvents();
  }

  openSubmenu(button) {
    addClassToElement(this.contentElement, classes.is.visible);
    createSubmenu(button.parentElement, button);
  }

  closeSubmenu() {
    const contentElementTransitionDuration =
      parseFloat(getComputedStyle(this.contentElement).transitionDuration) *
      1000;

    removeClassToElement(this.activeSubmenu, classes.is.visible);
    removeClassToElement(this.contentElement, classes.is.visible);
    // Remove active submenu
    setTimeout(() => {
      this.activeSubmenu && this.activeSubmenu.remove();
      this.activeSubmenu = null;
    }, contentElementTransitionDuration);
  }

  selectGender(button) {
    if (!hasClassElement(button, classes.is.active)) {
      super.selectGender(button);
      const genderId = button.dataset.gender;
      this.genderButtonElements.forEach((element) => {
        removeClassToElement(element, classes.is.active);
      });
      addClassToElement(button, classes.is.active);
      createMenu(genderId);
    }
  }

  getActiveGenderText = () => {
    return Array.from(this.genderButtonElements).find((element) => {
      return hasClassElement(element, classes.is.active);
    })?.innerText;
  };

  initEvents() {
    listenDOMEvent(this.openButtonElement, 'click', () => {
      this.open();
    });

    this.closeButtonElements.forEach((buttonCloseMenuMobile) => {
      listenDOMEvent(buttonCloseMenuMobile, 'click', () => {
        this.close();
      });
    });

    this.categoryButtons.forEach((buttonCategory) => {
      listenDOMEvent(buttonCategory, 'click', (e) => {
        e.stopPropagation();
        this.openSubmenu(e.currentTarget);
      });
    });

    this.genderButtonElements.forEach((buttonGenderMobile) => {
      listenDOMEvent(buttonGenderMobile, 'click', (e) => {
        this.selectGender(e.target);
      });
    });
  }
}
